var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { BdGraphStateMap, GraphNodeState } from '../../../../lib/graph/graph.model';
import * as deepEqual from 'fast-deep-equal';
import { uuid } from '../../../shared/uuid';
import { classToClass } from 'class-transformer';
import { omit, isEmpty } from 'lodash';
import { LabelsService } from '../../../story/labels.service';
import { calculateLeafStateMap } from 'src/lib/graph/leaf-state';
import { ErrandType } from '../../../story/models/errands/errand-type.enum';
import { calculateMiniminumSynchronization } from './minimum-synchronization';
import { renamespaceValue, renamespaceKeys } from '../renamespace-utils';
import { GraphUtils } from 'src/lib/graph/graph-utils';
import * as i0 from "@angular/core";
import * as i1 from "../../../story/labels.service";
// next human engine version
function getRecipes() {
    if (Human.scene.colorRecipes) {
        return Human.scene.colorRecipes.getRecipes();
    }
    else {
        return [];
    }
}
// rules for propagating state up our BdGraph
var GraphNodeSync = /** @class */ (function () {
    function GraphNodeSync(recipes) {
        var _this = this;
        this.shown = 'majorityWins';
        this.selected = 'majorityWins';
        this.pickable = 'majorityWins';
        recipes.forEach(function (recipeName) {
            _this[recipeName] = 'majorityWins';
        });
    }
    return GraphNodeSync;
}());
var SerializeChapterService = /** @class */ (function () {
    function SerializeChapterService(labelService) {
        this.labelService = labelService;
    }
    // Query the synchronization and produce the minimum graph synchronization object
    SerializeChapterService.prototype.getMinimumGraphSync = function (graph, sync, namespaceMap) {
        // calculate leaf state based on synchronization
        var _this = this;
        // TODO: when are recipes defined?
        var recipes = getRecipes();
        var properties = Object.keys(new GraphNodeState(recipes)); // ["shown", "selected", "pickable"]
        // calculate the state of all leaves given the sync object.
        // leaf state is needed to then propagate back up the tree to build the min sync.
        var leafState = calculateLeafStateMap(graph, sync, properties);
        // minimize sync with inheritable properties: calculate graph state via upward propagation of leaf state
        var syncRules = JSON.parse(JSON.stringify(new GraphNodeSync(recipes)));
        var minSync = calculateMiniminumSynchronization(graph, syncRules, leafState);
        // copy over non-inheritable properties
        Object.entries(sync).forEach(function (_a) {
            var _b = __read(_a, 2), objectId = _b[0], objectState = _b[1];
            var diffSync = omit(objectState, properties);
            if (!isEmpty(diffSync)) {
                minSync[objectId] = __assign({}, minSync[objectId] || {}, diffSync);
            }
        });
        var renamedMinSync = new BdGraphStateMap();
        Object.entries(minSync).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], syncState = _b[1];
            renamedMinSync[_this.switchNamespace(id, namespaceMap)] = syncState;
        }, this);
        return renamedMinSync;
    };
    // Convert synchronization object to chapter properties
    SerializeChapterService.prototype.convertGraphSync = function (sync) {
        var _this = this;
        var showObjects = {};
        var selectObjects = {};
        var pickThroughObjects = {};
        var colorRecipeObjects = {};
        var synchronization = {};
        var recipes = getRecipes();
        Object.entries(sync).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], stateMap = _b[1];
            Object.entries(stateMap).forEach(function (_a) {
                var _b = __read(_a, 2), property = _b[0], value = _b[1];
                var _c, _d;
                if (property === 'shown') {
                    showObjects[id] = value;
                }
                else if (property === 'selected') {
                    selectObjects[id] = value;
                }
                else if (property === 'pickable') {
                    pickThroughObjects[id] = !value;
                }
                else if (recipes.find(function (recipeName) { return recipeName === property; })) {
                    colorRecipeObjects[property] = __assign({}, colorRecipeObjects[property], (_c = {}, _c[id] = value, _c));
                }
                else {
                    // keep in the synchronization object directly
                    synchronization[id] = __assign({}, synchronization[id] || {}, (_d = {}, _d[property] = value, _d));
                }
            }, _this);
        }, this);
        return {
            showObjects: showObjects,
            selectObjects: selectObjects,
            pickThroughObjects: pickThroughObjects,
            colorRecipeObjects: colorRecipeObjects,
            synchronization: synchronization
        };
    };
    SerializeChapterService.prototype.switchNamespace = function (id, namespaceMap) {
        return namespaceMap[id] || id;
    };
    // Serialize timeline maps
    SerializeChapterService.prototype.serializeTimelineMaps = function (chapter, namespaceMap) {
        var _this = this;
        var timelineMaps = chapter.timelineMap;
        timelineMaps.forEach(function (tmap) {
            tmap.data.timeline = _this.switchNamespace(tmap.data.timeline, namespaceMap);
        });
        return timelineMaps;
    };
    // serialize engine properties - Only non-default properties 
    SerializeChapterService.prototype.serializeProperties = function (huChapter) {
        var properties = {};
        var defaults = Human.properties.getDefaults();
        Object.entries(huChapter.properties).forEach(function (_a) {
            var _b = __read(_a, 2), property = _b[0], value = _b[1];
            if (!deepEqual(value, defaults[property])) {
                properties[property] = value;
            }
        }, this);
        // legacy properties to eventually be discarded
        var annotationLayout = Human.properties.properties['annotations.layout.type'];
        if (annotationLayout !== 'draggable') {
            properties['annotations.layout.type'] = annotationLayout;
        }
        return properties;
    };
    // serialize labels and hotspots
    SerializeChapterService.prototype.serializeHotspots = function (chapter, reverseNamespaces) {
        var _this = this;
        var hotspots = __spread(chapter.hotspots);
        var customData = {};
        chapter.labels.forEach(function (label) {
            var labelData = _this.labelService.serializeLabel(label, hotspots.length, reverseNamespaces);
            hotspots = __spread(hotspots, labelData.hotspots);
            customData = __assign({}, customData, labelData.data);
        });
        return {
            customData: customData,
            hotspots: hotspots
        };
    };
    // serialize background
    SerializeChapterService.prototype.serializeBackground = function (background) {
        if (!!background) {
            return classToClass(background);
        }
        else {
            return {};
        }
    };
    // serialize ui
    SerializeChapterService.prototype.serializeUI = function (huChapter, ui) {
        if (isEmpty(ui)) {
            return { play: { count: 1 } };
        }
        else {
            return ui;
        }
    };
    // serialize chapter model into chapter data
    SerializeChapterService.prototype.serializeChapter = function (graph, chapter, inplace, namespaceMap, replaceObjectId) {
        if (inplace === void 0) { inplace = false; }
        if (replaceObjectId === void 0) { replaceObjectId = false; }
        var _a;
        var previousLabelNamespaces = chapter.labels.map(function (label) { return label.objectId; });
        if (replaceObjectId) {
            // Iterate through labels and replace object IDS with new namespaces
            chapter.labels.forEach(function (label) {
                label.objectId = renamespaceValue(label.objectId, namespaceMap);
                label.states.forEach(function (state) {
                    state.errands.forEach(function (errand) {
                        switch (errand.type) {
                            case ErrandType.flyToChapter:
                            case ErrandType.flyToObject:
                                errand.value = renamespaceValue(errand.value, namespaceMap);
                        }
                    });
                });
            });
        }
        // for all labels, make a reverse namespace map
        var reverseNamespaces = replaceObjectId
            ? previousLabelNamespaces.reduce(function (acc, labelObjectId) {
                var _a;
                var newNamespace = renamespaceValue(labelObjectId, namespaceMap);
                var oldNamespace = labelObjectId;
                return __assign({}, acc, (_a = {}, _a[newNamespace] = oldNamespace, _a));
            }, {})
            : undefined;
        // Hotspots are generated from labels, so we perform objectID conversion on labels before
        // generating the hotspots. 
        var hotspotData = this.serializeHotspots(chapter, reverseNamespaces);
        var customData = __assign({}, chapter.customData, hotspotData.customData);
        var chapterData = (_a = {
                id: inplace ? chapter.id : uuid.idWithPrefix('chapter'),
                displayName: chapter.info.displayName,
                description: chapter.info.description
            },
            _a[chapter.camera.action] = chapter.camera.location,
            _a.background = this.serializeBackground(chapter.background),
            _a.hotspots = hotspotData.hotspots,
            _a.clippingPlanes = chapter.clippingPlanes,
            _a.ui = this.serializeUI(chapter, chapter.ui),
            _a.graph = chapter.graph || {},
            _a.timelineMap = this.serializeTimelineMaps(chapter, namespaceMap),
            _a.customData = customData,
            _a.viewModes = chapter.viewModes,
            _a.lights = chapter.lights,
            _a.recipes = chapter.recipes || {},
            _a.transparencyMode = chapter.transparencyMode || '',
            _a.fallbackTransparency = chapter.fallbackTransparency || '',
            _a.properties = this.serializeProperties(chapter),
            _a.effects = chapter.effects || {},
            _a.options = chapter.options,
            _a.environment = chapter.environment || {},
            _a);
        // get data for restoring graph state
        var minSync = this.getMinimumGraphSync(graph, chapter.synchronization, namespaceMap);
        Object.entries(this.convertGraphSync(minSync))
            .forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            chapterData[key] = val;
        });
        if (replaceObjectId) {
            // Iterate through chapter properties and change the keys to new namespaces
            // e.g.: "showObjects": { "test_alzheimers_disease_brain_cross_section-root": true },
            ['showObjects', 'selectObjects', 'pickThroughObjects', 'colorRecipeObjects', 'synchronization'].forEach(function (value) {
                if (chapterData.hasOwnProperty(value)) {
                    chapterData[value] = renamespaceKeys(chapterData[value], namespaceMap);
                }
            });
        }
        return {
            chapter: chapterData,
            sourceId: chapter.id
        };
    };
    // serialize a single chapter from state
    SerializeChapterService.prototype.serializeSingleChapter = function (chapter, inplace, namespaceMap) {
        if (inplace === void 0) { inplace = false; }
        if (namespaceMap === void 0) { namespaceMap = {}; }
        var graphNodeData = new GraphNodeState(getRecipes());
        var graph = GraphUtils.createGraphFromSrc(Object.values(Human.scene.rootObjects), 'objectId', 'objects', graphNodeData);
        return this.serializeChapter(graph, chapter, inplace, namespaceMap);
    };
    // serialize all chapters in state
    SerializeChapterService.prototype.serialize = function (chapters, inplace, namespaceMap, replaceObjectId) {
        var _this = this;
        if (inplace === void 0) { inplace = false; }
        // prepare graph for graph state calculations
        var graphNodeData = new GraphNodeState(getRecipes());
        // #NOTE: [EM] This could be sped at by stashing the scene-graph on story load
        var graph = GraphUtils.createGraphFromSrc(Object.values(Human.scene.rootObjects), 'objectId', 'objects', graphNodeData);
        // serialize each chapter
        var chaptersData = [];
        var chapterIdMaps = {};
        chapters.forEach(function (chapter) {
            var serialized = _this.serializeChapter(graph, chapter, inplace, namespaceMap, replaceObjectId);
            chapterIdMaps[serialized.chapter.id] = serialized.sourceId;
            chaptersData.push(serialized.chapter);
        });
        return {
            chapters: chaptersData,
            sourceIdMap: chapterIdMaps // TODO: what is this???
        };
    };
    SerializeChapterService.ngInjectableDef = i0.defineInjectable({ factory: function SerializeChapterService_Factory() { return new SerializeChapterService(i0.inject(i1.LabelsService)); }, token: SerializeChapterService, providedIn: "root" });
    return SerializeChapterService;
}());
export { SerializeChapterService };
